export default __webpack_public_path__ + "static/media/icon-spalten-editieren.4358c6ee.svg";